import { useState, useEffect } from "react";
import Autocomplete from "../Autocomplete/Autocomplete";
import MultiSelectAutocomplete from "../MultiSelectAutocomplete/MultiSelectAutocomplete";
import { validateRows } from "../EntityTableTemplate/validateEntity";
import countryCodes from "../../../assets/files/country_codes.json";

export default function EditableForm({
  isNotScrollable,
  onClose,
  onSaved,
  title,
  showTitle,
  columns,
  params,
  setParams,
  state = "info", // "info" | "create" | "edit"
  services,  // new
  idField,   // new
  refParam,  // new,
  saveButtonName
}) {
  const deepCopyParams = (params) => params.map(item => ({ ...item }));
  
  const [localParams, setLocalParams] = useState(deepCopyParams(params));
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");

   // Whenever the modal opens, reset localParams
  useEffect(() => {
    setLocalParams(deepCopyParams(params));
  }, [params]);


  const update = (row, key, value) => {
    if (state === "info") return;
    const copy = [...localParams];
    copy[row] = { ...copy[row], [key]: value }; // ensures object itself is copied
    setLocalParams(copy);
  };



  const getCellErrorFromValidateRows = (row, col) => {
    const { invalidFields } = validateRows([row], [col]);
    return invalidFields.length ? invalidFields[0].message : null;
  };

  // =========================
  // CREATE / EDIT (REFRESH AFTER!)
  // =========================

  const handleSave = async () => {
    if (state === "info") return; // no save in info
    let resultMessage = "";
    
    let validationColumns = columns.filter(f => f.key !== "status");
    
    if(state == "edit"){
      validationColumns = validationColumns.filter(f => f.key !== "password");
      validationColumns = validationColumns.filter(f => f.key !== "confirm password");
    }

    if (validateRows) {
      const { isValid, invalidFields } = validateRows(localParams, validationColumns );
      if (!isValid) return;
    }

    const data = localParams[0];
    let payload = data;

    if(title=="Messages"){
        payload = { ...data, ticket_id: refParam };
    }
    
    else if(title=="Sign up" || title=="changePassword" || title=="ForgottenPassword_reset"){
      const { password, password2 } = data;

      if (password !== password2) {
        setError("Passwords doesn't match");
        setIsSaving(false);
        return;
      }
    }
    if(title=="ForgottenPassword_reset"){
      payload = { ...data, token: refParam };
    }
    
    try {
      setIsSaving(true);
      setError("");
      
      if (state === "edit" || state === "change_status") {
         const res = await services.update({ ...payload, [idField]: data[idField] }, services.services_url_names.update);
      } else {
        const res = await services.create(payload, services.services_url_names.create);
      }

      if(title=="Sign up"){
          window.location.href = "/SignUP_Email_Sent_Success";
      }

      else if(title=="Sign up" || title=="changePassword" || title=="ForgottenPassword_reset"){
        resultMessage = "saved";
          
      }
    }
    catch (err) {
      console.error(err);
      
      if(title=="Sign up"){
        if (err.response?.status === 403) {
          setError("Email already exists!");
        } else if (err.response?.status === 409) {
          //Username taken / email taken
          setError(err?.response?.data?.detail || "Something went wrong");
        } else if (err.response?.status === 404) {
          setError(
            "Incorrect passphrase! Please try again later or contact your administrator."
          );
        } else {
          setError("Unexpected error occurred");
        }
      }
      else if(title=="ForgottenPassword"){
      
      }
      else if(title=="ForgottenPassword_reset"){
        resultMessage = "false";
      }
      
    }
    finally {
      setIsSaving(false);
      if(title=="ForgottenPassword"){
        resultMessage = "If the email exists, a verification has been sent! Check your spam folder if you don't see it.";
        }
      else if(title=="changePassword" || title=="updateUserProfile" ){
        resultMessage = "saved";
      }
      else if (title =="setUserNewEmail")
      {
        resultMessage = "If the email exists, a verification has been sent! Check your spam folder if you don't see it.";
      }
    }
    setMessage(resultMessage);
    
    setParams(localParams);

    //console.log(resultMessage);
    await onSaved?.({ message: resultMessage });
  };
    
  return (
    <div>
      {showTitle && (
        <h2 style={{ marginBottom: 50, fontWeight: 600, fontSize: 18, color: "crimson"}}>
          {state === "info"
            ? "Information of"
            : state === "create"
            ? "Create"
            : state === "edit"
            ? "Edit"
            : ""}{" "}
          {title}
        </h2>
      )}

      <div style={{ maxHeight: isNotScrollable ? undefined : "400px", overflowY: isNotScrollable ? "visible" : "auto", paddingRight: 8 }}>
        {localParams.map((row, rowIndex) => (
          <div key={rowIndex} style={{ marginBottom: 24, borderBottom: '1px solid #eee', paddingBottom: 16 }}>
            {columns.map((col) => {

              if (col.state && !col.state.includes(state)) {
                return null;
              }

              const errorMessage = getCellErrorFromValidateRows(row, col);

              // Read-only view for info
              if (state === "info" || state === "" || state === null) {
                return (
                  <div key={col.key} style={{ marginBottom: 12 }}>
                    <label style={{ display: "block", fontWeight: 500, marginBottom: 4 }}>{col.key}</label>
                    <div style={{ minHeight: 28, padding: 4 }}>{row[col.key] || "-"}</div>
                  </div>
                );
              }

              // Editable fields for create/edit
              return (
                
                <div key={col.key} style={{ marginBottom: 12 }}>
                  <label style={{ display: "block", fontWeight: 500, marginBottom: 4 }}>{col.key}</label>

                  {/*JSON.stringify(row, null, 2)*/}
                  {col.key === "phone_number" ? (
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                      
                      <Autocomplete
                        options={countryCodes}
                        value={row["country_code"]}
                        placeholder="Code"
                        onChange={(val) => update(rowIndex, "country_code", val)}
                        style={{ "--autocomplete-width": "90px" }}
                      />

                      <input
                        className="MyInput"
                        value={row["phone_number"] || ""}
                        placeholder="Phone number"
                        onChange={(e) => update(rowIndex, "phone_number", e.target.value)}
                        style={{ flex: 1 }}
                      />

                    </div>
                  ) : col.type === "Autocomplete" ? (
                    <Autocomplete
                      options={col.Autocomplete || []}
                      value={row[col.key]}
                      placeholder={col.placeholder}
                      onChange={(val) => update(rowIndex, col.key, val)}
                    />
                  ) : col.type === "MultiSelectAutocomplete" ? (
                    <MultiSelectAutocomplete
                      mode="multiselect"
                      options={col.MultiSelectAutocomplete || []}
                      value={row[col.key] || []}
                      placeholder={col.placeholder}
                      onChange={(val) => update(rowIndex, col.key, val)}
                    />
                  ) : col.type === "select" ? (
                    <Autocomplete
                      value={row[col.key] || ""}
                      onChange={(val) => update(rowIndex, col.key, val)}
                      options={col.SELECT_OPTIONS}
                      placeholder={col.placeholder || "Select an option"}
                      mode="select"       // or "select" if no typing
                    />
                  ) : col.type === "textarea" ?(
                    <textarea className="MyInput"
                      value={row[col.key] || ""}
                      placeholder={col.placeholder}
                      onChange={(e) => update(rowIndex, col.key, e.target.value)}
                      rows={col.rows || 4}
                    />
                  ): col.type === "password" ?(
                     <input className="MyInput"
                     type="password"
                      name={`${col.key}_new`} // helps avoid autofill
                      autoComplete="new-password" // browser saved MOST password
                      value={row[col.key] || ""}
                      placeholder={col.placeholder}
                      onChange={(e) => update(rowIndex, col.key, e.target.value)}
                    />
                  )
                  : (
                    <input className="MyInput"
                      value={row[col.key] || ""}
                      placeholder={col.placeholder}
                      onChange={(e) => update(rowIndex, col.key, e.target.value)}
                    />
                  )}

                  {errorMessage && <div style={{ color: '#ff5252', fontSize: 12 }}>{errorMessage}</div>}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {error && (
        <div style={{ color: "red", marginTop: "12px" }}>
          {error}
        </div>
      )}
      {message && (
        <div style={{ color: "green", marginTop: "12px" }}>
          {message}
        </div>
      )}

      {/* Footer with Cancel / Save */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12, gap: 8, borderTop: "1px solid #eee", paddingTop: 12 }}>
        <button className="label-btn" style={{ "--label-btn-color": "#43A047" }} onClick={onClose}>Cancel</button>
        {state !== "info" && (
          <button className="label-btn" 
          style={{ "--label-btn-color": "#43A047" }} onClick={handleSave}
          disabled={isSaving}>
            {isSaving ? (
              <div className="spinner" style={{"--s-w":"16px", "--s-h":"16px"}}></div>
               ) : (
                saveButtonName
              )}
            </button>
        )}
      </div>
    </div>
  );
}
